<template>
    <div>
        <Head></Head>
        <div class="menu-list">
            <div class="content">
                <ul class="menu">
                    <li class="menu-item" :class="{active:active==item.navCode}" v-for="(item, index) in menuList"><a href="javascript:void(0);" @click="gotoUrl(item)">{{item.navName}}</a></li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
import Head from "./Head";
import Footer from "./Footer";

export default {
    components: {
        Head
    },
    data(){
        return {
            active: -1, //默认全部不高亮
            menuList: [],
        }
    },
    watch:{
        $route:{
            handler:function(val, oldVal){
                // console.log('hander', val);
                this.updateActive(val);
            },
            deep: true
        }
    },
    mounted(){
        this.updateActive(this.$route)

        this.loadData();
    },
    methods:{
        loadData(){    //加载菜单
            // 获取分站类型
            const siteType = this.$store.state.siteType;
            let parentTreeCode = '017'
            if(siteType === 'zhuhai'){
                parentTreeCode = '015'
            }
            if(siteType === 'zhaoqing'){
                parentTreeCode = '016'
            }


              this.$http.post('/core/cms/a/webNavigate/treelistauth', {parentTreeCode: parentTreeCode})
              .then(res=>{
                  if(res.data.state == 0){
                      // console.log('menu', res.data.result);
                    
                      for(let item of res.data.result){
                        if (item.parentTreeCode == parentTreeCode) {
                            //仅一级菜单
                            this.menuList.push(item);
                        }
                      }
                  }
              }).catch(err=>{
              })
        },
        gotoUrl(item){    //跳转链接
            if (item.linkUrl) {
                // console.log('这里', item.linkUrl);
                if (item.linkUrl && item.linkUrl.indexOf("_blank:") == 0) {
                    //新开窗口
                    let url = item.linkUrl.substring("_blank:".length);
                    window.open(url);
                    return;
                } else if (item.linkUrl && item.linkUrl.indexOf("_dialog:") == 0) {
                    let dialogId = 'dialog' + Math.floor(Math.random() * 1000000)
                    let url = item.linkUrl.substring("_dialog:".length);
                    window.openDialog(dialogId, '', url, {}, '95%', window.innerHeight - 80, function (callbackData) {
                        //回调
                    });

                } else {
                    // router 无法把 query 参数放到链接中，所以需要转换
                    let urlArr = item.linkUrl.split('?');
                    let queryJSON = {};
                    let paramsArr = [];
                    if(urlArr[1] && urlArr[1] != ''){
                      paramsArr = urlArr[1].split('&');
                      
                      paramsArr.forEach(param => {
                          const [key, value] = param.split('=');
                          queryJSON[key] = decodeURIComponent(value);
                      });
                    }

                    queryJSON['navCode'] = item.navCode;    //导航栏编码

                    //跳转
                    this.$router.push({ path: urlArr[0], query: queryJSON })
                }
            }
        },
        updateActive:function(val){
            this.active = val.query.navCode;
            if(val.name == 'Index'){
                this.active = 'HOME';
            }else if(val.path.indexOf('/about') >= 0){
                this.active = 'ABOUT';
            }else if(val.name == ''){
                //TODO: 其他变化
            }
        },

        
    }
}
</script>

<style scoped>
.menu-list{

    background: #007EEC;
    box-shadow: 0 2px 4px 0 rgba(221,221,221,0.50);
}
    .content{
        background: #007EEC;
        box-shadow: 0 2px 4px 0 rgba(221,221,221,0.50);
        width: 1200px;
    }
    .menu{
        list-style: none;
        display: flex;
        justify-content: space-between;
        margin: 24px 0 0 0;
        
    }
    .menu .active{
        border-bottom: 3px solid #fff;
        
    }
    .menu-item{
        padding: 14px 10px;
    }
    .menu-item a{
        font-family: SourceHanSansCN-Medium;
        font-size: 18px;
        color: #fff;
        letter-spacing: 0;
        text-align: justify;
        text-decoration: none;
       
        
    }
    .menu-item.active a{
        color: #fff;
    }
    .menu-item a:hover{
        color: #ccc;
    }
    
</style>
